import React, { useEffect, lazy, createElement } from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const testimonials = [{
  quote: 'Después de meses de separación, la evidencia del tarot me abrió los ojos. Con el acompañamiento espiritual, a los 7 días volvimos a hablar...',
  name: 'C. G.',
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  quote: 'Estaba desesperada por la distancia. El Maestro Salomón me ayudó a volver...',
  name: 'A. V.',
  photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  quote: 'Te dice la verdad sin rodeos. Logré recuperar la armonía con mi esposo...',
  name: 'M. L.',
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop&crop=faces'
}];
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    if (window.fbq) {
      window.fbq('init', '1038896145376572');
      window.fbq('track', 'PageView');
    }
  }, []);
  const handleWhatsAppClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
      window.fbq('trackCustom', 'WhatsAppClick');
    }
  };
  return <div className="relative w-full min-h-screen bg-black font-['Inter',sans-serif] text-white selection:bg-yellow-500/30" data-id="element-0">
      {/* Background Image - fixed to cover whole scroll */}
      <div className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-40" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?q=80&w=1200&auto=format&fit=crop")'
    }} aria-hidden="true" data-id="element-1" />
      <div className="fixed inset-0 z-0 bg-gradient-to-b from-black/85 via-black/60 to-black/95" aria-hidden="true" data-id="element-2" />

      {/* Main Content Container */}
      <div className="relative z-10 w-full max-w-md mx-auto px-5 py-6 flex flex-col gap-5" data-id="element-3">
        {/* Header Section */}
        <div className="text-center space-y-3 mt-2" data-id="element-4">
          <h1 className="font-['Cinzel',serif] text-2xl sm:text-3xl font-bold text-[#D4AF37] leading-tight text-shadow-md" data-id="element-5">
            ¿Tu pareja se alejó y quieres que regrese?
          </h1>
          <div className="space-y-1.5" data-id="element-6">
            <h2 className="text-base sm:text-lg font-medium text-yellow-100 text-shadow-sm" data-id="element-7">
              Salomón te guía en el Amor y el Destino.
            </h2>
            <p className="text-xs sm:text-sm text-gray-200 leading-snug max-w-[90%] mx-auto text-shadow-sm" data-id="element-8">
              Recupera la armonía con tu ser amado a través de la sabiduría
              ancestral del Maestro Salomón.
            </p>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="space-y-3 bg-black/40 backdrop-blur-md p-4 rounded-2xl border border-[#D4AF37]/30 shadow-[0_0_20px_rgba(0,0,0,0.5)]" data-id="element-9">
          <div className="flex items-start gap-3" data-id="element-10">
            <span className="text-lg leading-none mt-0.5" data-id="element-11">💚</span>
            <div className="leading-tight" data-id="element-12">
              <strong className="text-[#D4AF37] text-sm" data-id="element-13">Amor: </strong>
              <span className="text-xs sm:text-sm text-gray-100" data-id="element-14">
                Retornos, reconciliación y corte de rivales.
              </span>
            </div>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" data-id="element-15" />

          <div className="flex items-start gap-3" data-id="element-16">
            <span className="text-lg leading-none mt-0.5" data-id="element-17">🪙</span>
            <div className="leading-tight" data-id="element-18">
              <strong className="text-[#D4AF37] text-sm" data-id="element-19">
                Dinero y Suerte:{' '}
              </strong>
              <span className="text-xs sm:text-sm text-gray-100" data-id="element-20">
                Apertura de caminos y éxito económico.
              </span>
            </div>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" data-id="element-21" />

          <div className="flex items-start gap-3" data-id="element-22">
            <span className="text-lg leading-none mt-0.5" data-id="element-23">🌿</span>
            <div className="leading-tight" data-id="element-24">
              <strong className="text-[#D4AF37] text-sm" data-id="element-25">
                Salud Espiritual:{' '}
              </strong>
              <span className="text-xs sm:text-sm text-gray-100" data-id="element-26">
                Limpieza de energías densas y bloqueos.
              </span>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center space-y-3" data-id="element-27">
          <motion.p className="text-xs sm:text-sm font-medium text-yellow-200" animate={{
          opacity: [0.7, 1, 0.7]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-28">
            👇 Toca el botón ahora mismo para realizar tu consulta privada y
            confidencial.
          </motion.p>

          <motion.a href="https://wa.me/qr/B7R5JYMJD6YXI1" target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick} className="block w-full py-3.5 px-4 bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 text-black font-bold text-sm sm:text-base rounded-full border border-yellow-300 tracking-wide shadow-lg" animate={{
          scale: [1, 1.04, 1],
          boxShadow: ['0px 0px 10px rgba(212,175,55,0.4)', '0px 0px 25px rgba(212,175,55,0.9)', '0px 0px 10px rgba(212,175,55,0.4)']
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-29">
            🔮 CONSULTAR EL TAROT POR WHATSAPP
          </motion.a>
        </div>

        {/* Testimonials Section */}
        <section className="pt-2" aria-labelledby="testimonios-heading" data-id="element-30">
          <h3 id="testimonios-heading" className="font-['Cinzel',serif] text-center text-base sm:text-lg font-semibold text-[#D4AF37] tracking-widest uppercase mb-4" data-id="element-31">
            Testimonios Reales
          </h3>

          <div className="space-y-3" data-id="element-32">
            {testimonials.map((t, i) => <motion.div key={t.name} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="flex gap-3 items-start bg-black/50 backdrop-blur-md p-3.5 rounded-2xl border border-[#D4AF37]/25" data-id="element-33">
                <img src={t.photo} alt={`Testimonio de ${t.name}`} loading="lazy" className="w-12 h-12 rounded-full object-cover border-2 border-[#D4AF37]/60 shadow-[0_0_10px_rgba(212,175,55,0.3)] flex-shrink-0" data-id="element-34" />
                <div className="flex-1 min-w-0" data-id="element-35">
                  <div className="text-yellow-400 text-xs tracking-wider mb-1" aria-label="5 estrellas" data-id="element-36">
                    ★ ★ ★ ★ ★
                  </div>
                  <p className="text-xs sm:text-sm text-gray-100 leading-snug italic" data-id="element-37">
                    "{t.quote}"
                  </p>
                  <p className="text-[11px] text-[#D4AF37] font-semibold mt-1" data-id="element-38">
                    — {t.name}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Closing Destiny Message */}
        <div className="text-center pt-2 pb-1" data-id="element-39">
          <div className="w-24 h-px mx-auto bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent mb-4" data-id="element-40" />
          <p className="font-['Cinzel',serif] text-sm sm:text-base text-yellow-100 leading-relaxed" data-id="element-41">
            El destino puso este mensaje en tu camino.
            <br data-id="element-42" />
            <span className="text-[#D4AF37] font-semibold" data-id="element-43">
              No dejes pasar más tiempo.
            </span>
          </p>
        </div>

        {/* Final CTA repeat for conversion */}
        <motion.a href="https://wa.me/qr/B7R5JYMJD6YXI1" target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick} className="block w-full py-3.5 px-4 bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 text-black font-bold text-sm sm:text-base rounded-full border border-yellow-300 tracking-wide shadow-lg text-center mb-4" animate={{
        scale: [1, 1.04, 1],
        boxShadow: ['0px 0px 10px rgba(212,175,55,0.4)', '0px 0px 25px rgba(212,175,55,0.9)', '0px 0px 10px rgba(212,175,55,0.4)']
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-44">
          🔮 CONSULTAR AHORA POR WHATSAPP
        </motion.a>
      </div>
    </div>;
}